import { render } from "./personalElectrical.vue?vue&type=template&id=1fa2d5f8&scoped=true"
import script from "./personalElectrical.vue?vue&type=script&lang=js"
export * from "./personalElectrical.vue?vue&type=script&lang=js"

import "./personalElectrical.vue?vue&type=style&index=0&id=1fa2d5f8&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa2d5f8"]])

export default __exports__